import { readParquet } from '../../../services/productivityService'; // Assuming the function is in this service file
import { makeActionCreator } from '../../../config/store/utils';

// Action Types
export const GET_METRICS = 'GET_METRICS';
export const GET_METRICS_ERROR = 'GET_METRICS_ERROR';
export const GET_METRICS_SUCCESS = 'GET_METRICS_SUCCESS';

// Action Creators
export const onGetMetrics = makeActionCreator(GET_METRICS);
export const onGetMetricsError = makeActionCreator(
  GET_METRICS_ERROR,
  'payload'
);
export const onGetMetricsSuccess = makeActionCreator(
  GET_METRICS_SUCCESS,
  'payload'
);

// Async action to fetch the Parquet data
export const onGetMetricsThunk = () => async dispatch => {
  dispatch(onGetMetrics()); // Start loading
  try {
    const type = 'tabla_horometros_odometros';
    const response = await readParquet({ type });
    const data = JSON.parse(response.data).map((item, index) => {
      return {
        ...item,
        id: `${index + 1}`,
        event_time: new Date(item.event_time).toLocaleString(),
      };
    });
    dispatch(onGetMetricsSuccess({ data: data })); // Dispatch success with the data
  } catch (error) {
    dispatch(
      onGetMetricsError({
        error: error.message || 'Error fetching data',
      })
    ); // Dispatch error
  }
};
